import * as React from 'react';
import {useMutation} from '@tanstack/react-query';


export type MutationResult<TData, TError, TVariables> = {
  data: TData | null | undefined;
  error: TError | null | undefined;
  isError: boolean;
  isIdle: boolean;
  isLoading: boolean;
  isPending: boolean;
  isPaused: boolean;
  isSuccess: boolean;
  mutate: (variables: TVariables) => void;
  mutateAsync: (variables: TVariables) => Promise<TData>;
  reset: () => void;
  status: 'idle' | 'loading' | 'success' | 'error';
  variables: TVariables | null | undefined;
};

type MutationOptions<TData, TError, TVariables> = {
  mutationFn: (variables: TVariables) => Promise<TData>;
  onSuccess?: (
    data: TData,
    variables: TVariables,
  ) => undefined | Promise<undefined>;
  onError?: (
    error: TError,
    variables: TVariables,
  ) => undefined | Promise<undefined>;
  onSettled?: (
    data: TData | null | undefined,
    error: TError | null | undefined,
    variables: TVariables,
  ) => undefined | Promise<undefined>;
  onMutate?: (variables: TVariables) => undefined | Promise<undefined>;
  retry?: boolean | number;
  retryDelay?: number;
  gcTime?: number;
  networkMode?: 'online' | 'always' | 'offlineFirst';
};

// @ts-expect-error - TS2370 - A rest parameter must be of an array type.
export function useAsyncAction<A>(action: (...args: A) => unknown): {
  isLoading: boolean;
  // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
  act: (...args: A) => Promise<void>;
} {
  // @ts-expect-error - TS2322 - Type 'UseMutationResult<void, Error, A, unknown>' is not assignable to type 'MutationResult<undefined, Error, A>'.
  const mutation: MutationResult<undefined, Error, A> = useMutation({
    mutationFn: async (...args) => {
      // @ts-expect-error - TS2345 - Argument of type '[variables: A]' is not assignable to parameter of type 'A'.
      await action(...args);
    },
  });

  return {
    isLoading: mutation.isLoading,
    // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
    act: async (...args) => {
      if (!mutation.isLoading) {
        await mutation.mutateAsync(args);
      }
    },
  };
}

// @ts-expect-error - TS2370 - A rest parameter must be of an array type.
export function useAsyncActionHandler<A>(action: (...args: A) => unknown): {
  isLoading: boolean;
  error: Error | null | undefined;
  // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
  act: (...args: A) => Promise<void>;
} {
  // @ts-expect-error - TS2322 - Type 'UseMutationResult<void, Error, A, unknown>' is not assignable to type 'MutationResult<undefined, Error, A>'.
  const mutation: MutationResult<undefined, Error, A> = useMutation({
    mutationFn: async (...args) => {
      // @ts-expect-error - TS2345 - Argument of type '[variables: A]' is not assignable to parameter of type 'A'.
      await action(...args);
    },
  });

  return {
    isLoading: mutation.isLoading,
    error: mutation.error,
    // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
    act: async (...args) => {
      if (!mutation.isLoading) {
        await mutation.mutateAsync(args);
      }
    },
  };
}

export function useApiMutation<TData, TError, TVariables>(
  options: MutationOptions<TData, TError, TVariables>,
): MutationResult<TData, TError, TVariables> {
  // @ts-expect-error - TS2322 - Type 'UseMutationResult<TData, TError, TVariables, Promise<undefined> | undefined>' is not assignable to type 'MutationResult<TData, TError, TVariables>'.
  return useMutation(options);
}
